import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { alpha, lighten } from '@mui/system';

type TagBaseProps = {
  tagColor: string | null;
};

const TagBase = styled('li')<TagBaseProps>(
  ({ theme, tagColor }) => {
    if (tagColor === null) {
      return {
        border: `1px solid ${theme.palette.divider}`,
      };
    }

    const adjustedTagColor = theme.isDark ? lighten(tagColor, 0.15) : tagColor;

    return {
      color: alpha(theme.palette.getContrastText(adjustedTagColor), 0.9),
      backgroundColor: adjustedTagColor,
      border: `1px solid ${adjustedTagColor}`,
      '.MuiIconButton-root': {
        color: alpha(theme.palette.getContrastText(adjustedTagColor), 0.9),
      },
    };
  },
  addHighContrastStyles(({ theme }) => ({
    color: theme.isDark ? 'black' : 'white',
    backgroundColor: theme.palette.divider,
    border: `1px solid ${theme.palette.divider}`,
    '.MuiIconButton-root': {
      color: theme.isDark ? 'black' : 'white',
    },
  })),
);

export default TagBase;
